import {
	IonBackButton,
	IonButton,
	IonButtons,
	IonHeader,
	IonIcon,
	IonPage,
	useIonRouter,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { DynamicAvatar } from "@/components/CoreValue/DynamicAvatar";
import { CoreValueRankingRow } from "@/components/CoreValue/RankingRow";
import { Button } from "@/components/Global/Button";
import { Content } from "@/components/Global/Content";
import { Toolbar } from "@/components/Global/Toolbar";
import { backendService } from "@/lib/backend";
import { REQUIRED_CORE_VALUE_ACCURACY_TO_CHOOSE_CORE_VALUES } from "@/lib/constants";
import { arrowLeftIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { questionMarkCircleIcon } from "@/lib/icons/@heroicons/react/24/outline";
import { useMyProgression } from "@/lib/query/functions/user/progression";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function CoreValueOverview() {
	const { t } = useTranslation();
	const present = useSelectorModalStore.use.present();
	const [myProgression] = useMyProgression();
	const router = useIonRouter();

	const selectedCoreValuesQuery = useQuery({
		queryKey: ["coreValue", "selected"],
		queryFn: () => backendService.corevalues.selectedCoreValuesControllerGetAll(),
	});

	return (
		<IonPage>
			<IonHeader className="ion-no-border">
				<Toolbar className="ion-p-2 ion-pb-2 ion-pt-6 ion-min-h-16 plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),--spacing(4))]">
					<IonButtons slot="secondary">
						<IonBackButton
							data-attr="page.core-values.detail.back"
							data-touch-target
							defaultHref={Routes.Dashboard()}
							color="light"
							className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
							icon={arrowLeftIcon}
							text=""
						/>
					</IonButtons>
					<IonButtons slot="end">
						<IonButton
							shape="round"
							className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
							onClick={() => present("coreValuesExplainer")}
						>
							<IonIcon slot="icon-only" icon={questionMarkCircleIcon} />
						</IonButton>
					</IonButtons>
				</Toolbar>
			</IonHeader>
			<Content>
				<div className="space-y-12 pt-4">
					<DynamicAvatar />

					<div className="space-y-2">
						{selectedCoreValuesQuery.data?.data?.map((coreValue, i) => (
							<CoreValueRankingRow
								onClick={() => {
									present("coreValuesDetail", {
										item: {
											name: coreValue.coreValue.name,
											reason: coreValue.reason,
											score: coreValue.matchScore,
										},
									});
								}}
								enableAnimation={false}
								key={coreValue.coreValue.id}
								data={{ ...coreValue.coreValue, number: i + 1, matchScore: coreValue.matchScore }}
							/>
						))}
					</div>
				</div>
				<Button
					data-attr="modal.friend-check.completed.cancel"
					expand="block"
					variant="secondary"
					onClick={() => {
						if (
							myProgression.core_value_accuracy >=
							REQUIRED_CORE_VALUE_ACCURACY_TO_CHOOSE_CORE_VALUES
						) {
							router.push(Routes.CoreValuesSort());
						} else {
							present("coreValuesAccuracyExplainer");
						}
					}}
				>
					{t("core-values.compile-top-5")}
				</Button>
			</Content>
		</IonPage>
	);
}
